import { useLocation } from 'react-router-dom';
import { getCompanyByPath } from '~/utils/companyUtils';
import { Company } from '~/interfaces/CompanyConfig';

export const useIsFrom = (company: Company): boolean => {
  const { pathname } = useLocation();
  return getCompanyByPath(pathname) === company;
};

export default useIsFrom;
